export default{
  navcollapse:false,
  saleAdviceData:{},
  saleAdviceDataAtt:{},
  btnStatus:{},
  resourcelist:[],
  salesresourcelist:[],
  selectlist:[],
  languagetype:'' ,
  control:{},
  controlrouter:{},
  navPathList:[],
  waitingTotal:'', //等待审批数量,小红点
  channelWaitingTotal:'',//等待审批数量,小红点(渠道)
  logintype:'',  //用于app组件获取登陆状态
  show_loading:false ,
  allprojecttab:'1',
  reatab:'leadCapture',
  domaintab:'leadCapture',
  agentboxtab:'leadCapture',
  campaignHostTab:'campaignHostSetting',
  approvaltab:'teamBaseSetting',
  sharedlistingtab:'first',
  listingapprovaltab:'first',
  marketplacetab:'1',
  marketplacesubtab:'1',

  menuactive:'1',
  menunav:{},
  internalpendingcount:{},
  marketplacependingcount:'',
  departmenttab:'d-0',
  projectType:'', //保存判断是否是singlelisting还是project的变量
  campaignData:{},
  singleListData:{},
  sharedListData:{},
  logoimagedark: '',
  sessionExpired: false,
  token: null,
  edition: 0,
  commissionModuleEnabled: false,
}



// WEBPACK FOOTER //
// ./src/store/state.js